import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"],
  _excluded2 = ["valid"];
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
var fileDownload = require("js-file-download");
import axios from "axios";
import { request } from "@/js/http/http_request.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { wineNaming } from "@/js/wine/wine.js";
import { getFullNameUser } from "@/js/user/user.js";
import { STOCK_TRANSFER_DOMESTIC, listWineTypes } from "@/js/lists.ts";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultFormReference = {
  reference: "",
  valid: false
};
var defaultFormComment = {
  comment: "",
  valid: false
};
export default {
  name: "StockTransferDomesticFormModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    id: Number | null
  },
  data: function data() {
    return {
      dialog: false,
      entity: null,
      gettingEntity: {
        isPending: false,
        cancellationToken: null
      },
      updatingReference: {
        isConfiguring: false,
        form: _objectSpread({}, defaultFormReference),
        isPending: false,
        cancellationToken: null
      },
      cancellingContent: {
        isPending: false
      },
      handlingComment: {
        updating: {
          isConfiguring: false,
          form: _objectSpread({}, defaultFormComment),
          isPending: false,
          cancellationToken: null
        },
        removing: {
          isPending: false,
          cancellationToken: null
        }
      },
      delivering: {
        isPending: false,
        cancellationToken: null
      },
      cancelling: {
        isPending: false,
        cancellationToken: null
      },
      exportingPdf: {
        isPending: false,
        cancellationToken: null
      },
      STOCK_TRANSFER_DOMESTIC: STOCK_TRANSFER_DOMESTIC,
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isLoading: function isLoading() {
      return this.gettingEntity.isPending;
    },
    isEditable: function isEditable() {
      var _this$entity;
      return ((_this$entity = this.entity) === null || _this$entity === void 0 ? void 0 : _this$entity.status) === STOCK_TRANSFER_DOMESTIC.STATUS.PENDING.id;
    },
    isCancellable: function isCancellable() {
      return this.isEditable;
    },
    isCancelled: function isCancelled() {
      var _this$entity2;
      return ((_this$entity2 = this.entity) === null || _this$entity2 === void 0 ? void 0 : _this$entity2.status) === STOCK_TRANSFER_DOMESTIC.STATUS.CANCELLED.id;
    },
    isDelivered: function isDelivered() {
      var _this$entity3;
      return ((_this$entity3 = this.entity) === null || _this$entity3 === void 0 ? void 0 : _this$entity3.status) === STOCK_TRANSFER_DOMESTIC.STATUS.DELIVERED.id;
    },
    canCancelContent: function canCancelContent() {
      var _this$entity4, _this$entity5;
      return this.isEditable && !(((_this$entity4 = this.entity) === null || _this$entity4 === void 0 || (_this$entity4 = _this$entity4.forOrder) === null || _this$entity4 === void 0 ? void 0 : _this$entity4.id) > 0) && ((_this$entity5 = this.entity) === null || _this$entity5 === void 0 || (_this$entity5 = _this$entity5.parts) === null || _this$entity5 === void 0 ? void 0 : _this$entity5.length) > 1;
    },
    partsByWine: function partsByWine() {
      var _this$entity6,
        _this2 = this;
      if (!((_this$entity6 = this.entity) !== null && _this$entity6 !== void 0 && (_this$entity6 = _this$entity6.parts) !== null && _this$entity6 !== void 0 && _this$entity6.length) > 0) return null;
      var partsByWine = [];
      this.entity.parts.forEach(function (part) {
        var newPart = {
          id: part.id,
          quantity: part.quantity,
          fromStockPart: _objectSpread({}, part.fromStockPart),
          toStockPartId: part.toStockPartId
        };
        var existintPartByWine = partsByWine === null || partsByWine === void 0 ? void 0 : partsByWine.find(function (x) {
          return x.wine.id === part.wine.id;
        });
        if (!existintPartByWine) {
          var newPartByWine = {
            wine: _objectSpread({}, part.wine),
            parts: [newPart]
          };
          newPartByWine.wine.displayName = wineNaming(_this2.$whitelabel, part.wine.naming_data, true, true, true);
          partsByWine.push(newPartByWine);
        } else {
          existintPartByWine.parts.push(newPart);
        }
      });
      return partsByWine.sort(function (a, b) {
        return a.wine.displayName < b.wine.displayName;
      });
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isLoading || this.updatingReference.isPending || this.handlingComment.updating.isPending || this.handlingComment.removing.isPending || this.delivering.isPending || this.cancelling.isPending;
    },
    isAnySubformInProgress: function isAnySubformInProgress() {
      return this.handlingComment.updating.isConfiguring || this.updatingReference.isConfiguring;
    }
  },
  created: function created() {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    startEditReference: function startEditReference() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.updatingReference.isConfiguring = true;
              _this3.updatingReference.form.reference = _this3.entity.reference;
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    cancelUpdatingReference: function cancelUpdatingReference() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.updatingReference.isConfiguring = false;
              _this4.updatingReference.form = _objectSpread({}, defaultFormReference);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    saveUpdatingReference: function saveUpdatingReference() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this5$updatingRefere;
        var _this, _this5$updatingRefere2, valid, withoutValid;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this5.updatingReference.isPending = true;
              (_this5$updatingRefere = _this5.updatingReference.cancellationToken) === null || _this5$updatingRefere === void 0 || _this5$updatingRefere.cancel();
              _this5.updatingReference.cancellationToken = axios.CancelToken.source();
              _this = _this5;
              _this5$updatingRefere2 = _this5.updatingReference.form, valid = _this5$updatingRefere2.valid, withoutValid = _objectWithoutProperties(_this5$updatingRefere2, _excluded);
              _context5.next = 7;
              return request("/v1/stock-transfer-domestics/" + _this5.entity.id + "/reference", "put", withoutValid, true, "api", null, _this.updatingReference.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.updatingReference.isPending = false;
                          _this.updatingReference.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to update the reference", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 7:
              _this5.entity.reference = _this5.updatingReference.form.reference.trim();
              _this5.updatingReference.isConfiguring = false;
              _this5.updatingReference.form = _objectSpread({}, defaultFormReference);
              _this5.updatingReference.isPending = false;
              _this5.updatingReference.cancellationToken = null;
              _this5.$emit("entityUpdated");
              _this5.$toasted.show("Reference updated", {
                type: "success"
              });
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    confirmCancelContent: function confirmCancelContent(item) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this6.$refs.confirm.open("Remove product", "Are you sure to remove this product ? Please note that presold stocks must not be included in an order, and the bottles will be returned to their previous available stock.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(confirm) {
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!confirm) {
                          _context6.next = 3;
                          break;
                        }
                        _context6.next = 3;
                        return _this6.cancelContent(item);
                      case 3:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    cancelContent: function cancelContent(item) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this7.cancellingContent.isPending = true;
              _this = _this7;
              _context9.next = 4;
              return request("/v1/stock-transfer-domestics/parts/" + item.id, "delete", {}, true, "api").catch(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        _this.cancellingContent.isPending = false;
                        errorData = getErrorData(e, {}, "Unable to remove the product.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 4:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 4:
              _this7.entity.parts = _this7.entity.parts.filter(function (x) {
                return x.id !== item.id;
              });
              _this7.cancellingContent.isPending = false;
              _this7.$emit("entityUpdated");
              _this7.$toasted.show("Product removed.", {
                type: "success"
              });
            case 8:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    confirmDelivering: function confirmDelivering() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this8.$refs.confirm.open("Transfer done", "Are you sure you want to mark this transfer as done? Presold stocks will lose their #PRE-ARRIVAL tag. Warning: This operation cannot be undone.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(confirm) {
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        if (!confirm) {
                          _context10.next = 3;
                          break;
                        }
                        _context10.next = 3;
                        return _this8.deliver();
                      case 3:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x4) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    deliver: function deliver() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this9$delivering$can;
        var _this;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this9.delivering.isPending = true;
              (_this9$delivering$can = _this9.delivering.cancellationToken) === null || _this9$delivering$can === void 0 || _this9$delivering$can.cancel();
              _this9.delivering.cancellationToken = axios.CancelToken.source();
              _this = _this9;
              _context13.next = 6;
              return request("/v1/stock-transfer-domestics/" + _this9.entity.id + "/delivered", "put", {}, true, "api", null, _this.delivering.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.delivering.isPending = false;
                          errorData = getErrorData(e, {}, "Unable to deliver this transfer", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                return function (_x5) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 6:
              _this9.delivering.isPending = false;
              _this9.delivering.cancellationToken = null;
              _this9.$emit("entityUpdated");
              _this9.$toasted.show("Transfer done", {
                type: "success"
              });
              _this9.close();
            case 11:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    confirmCancelling: function confirmCancelling() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this10.$refs.confirm.open("Cancelling transfer", "Are you sure you want to cancel this transfer? Please note that presold stocks must not be included in an order, and the bottles will be returned to their previous available stock.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(confirm) {
                  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                    while (1) switch (_context14.prev = _context14.next) {
                      case 0:
                        if (!confirm) {
                          _context14.next = 3;
                          break;
                        }
                        _context14.next = 3;
                        return _this10.cancel();
                      case 3:
                      case "end":
                        return _context14.stop();
                    }
                  }, _callee14);
                }));
                return function (_x6) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    cancel: function cancel() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _this11$cancelling$ca;
        var _this;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _this11.cancelling.isPending = true;
              (_this11$cancelling$ca = _this11.cancelling.cancellationToken) === null || _this11$cancelling$ca === void 0 || _this11$cancelling$ca.cancel();
              _this11.cancelling.cancellationToken = axios.CancelToken.source();
              _this = _this11;
              _context17.next = 6;
              return request("/v1/stock-transfer-domestics/" + _this11.entity.id, "delete", {}, true, "api", null, _this.cancelling.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                    while (1) switch (_context16.prev = _context16.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.cancelling.isPending = false;
                          errorData = getErrorData(e, {}, "Unable to cancel this transfer");
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context16.stop();
                    }
                  }, _callee16);
                }));
                return function (_x7) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 6:
              _this11.cancelling.isPending = false;
              _this11.cancelling.cancellationToken = null;
              _this11.$emit("entityUpdated");
              _this11.$toasted.show("Transfer cancelled", {
                type: "success"
              });
              _this11.close();
            case 11:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    startEditComment: function startEditComment() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this12$entity$commen;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _this12.handlingComment.updating.isConfiguring = true;
              _this12.handlingComment.updating.form.comment = (_this12$entity$commen = _this12.entity.comment) !== null && _this12$entity$commen !== void 0 ? _this12$entity$commen : defaultFormComment.comment;
            case 2:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    cancelUpdatingComment: function cancelUpdatingComment() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _this13.handlingComment.updating.isConfiguring = false;
              _this13.handlingComment.updating.form = _objectSpread({}, defaultFormComment);
            case 2:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    confirmRemoveComment: function confirmRemoveComment() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _this14.$refs.confirm.open("Remove comment", "Are you sure to remove the comment ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(confirm) {
                  return _regeneratorRuntime().wrap(function _callee20$(_context20) {
                    while (1) switch (_context20.prev = _context20.next) {
                      case 0:
                        if (!confirm) {
                          _context20.next = 3;
                          break;
                        }
                        _context20.next = 3;
                        return _this14.removeComment();
                      case 3:
                      case "end":
                        return _context20.stop();
                    }
                  }, _callee20);
                }));
                return function (_x8) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }))();
    },
    removeComment: function removeComment() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var _this15$handlingComme;
        var _this;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _this15.handlingComment.removing.isPending = true;
              (_this15$handlingComme = _this15.handlingComment.removing.cancellationToken) === null || _this15$handlingComme === void 0 || _this15$handlingComme.cancel();
              _this15.handlingComment.removing.cancellationToken = axios.CancelToken.source();
              _this = _this15;
              _context23.next = 6;
              return request("/v1/stock-transfer-domestics/" + _this15.entity.id + "/comment", "delete", {}, true, "api", null, _this.handlingComment.removing.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee22$(_context22) {
                    while (1) switch (_context22.prev = _context22.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingComment.removing.isPending = false;
                          _this.handlingComment.removing.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to remove the comment.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context22.stop();
                    }
                  }, _callee22);
                }));
                return function (_x9) {
                  return _ref9.apply(this, arguments);
                };
              }());
            case 6:
              _this15.entity.comment = null;
              _this15.handlingComment.removing.isPending = false;
              _this15.handlingComment.removing.cancellationToken = null;

              //this.$emit("entityUpdated")
              _this15.$toasted.show("Comment removed.", {
                type: "success"
              });
            case 10:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }))();
    },
    saveComment: function saveComment() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var _this16$handlingComme;
        var _this, _this16$handlingComme2, valid, withoutValid;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _this16.handlingComment.updating.isPending = true;
              (_this16$handlingComme = _this16.handlingComment.updating.cancellationToken) === null || _this16$handlingComme === void 0 || _this16$handlingComme.cancel();
              _this16.handlingComment.updating.cancellationToken = axios.CancelToken.source();
              _this = _this16;
              _this16$handlingComme2 = _this16.handlingComment.updating.form, valid = _this16$handlingComme2.valid, withoutValid = _objectWithoutProperties(_this16$handlingComme2, _excluded2);
              _context25.next = 7;
              return request("/v1/stock-transfer-domestics/" + _this16.entity.id + "/comment", "put", withoutValid, true, "api", null, _this.handlingComment.updating.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee24$(_context24) {
                    while (1) switch (_context24.prev = _context24.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingComment.updating.isPending = false;
                          _this.handlingComment.updating.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to update the comment.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context24.stop();
                    }
                  }, _callee24);
                }));
                return function (_x10) {
                  return _ref10.apply(this, arguments);
                };
              }());
            case 7:
              _this16.entity.comment = _this16.handlingComment.updating.form.comment;
              _this16.handlingComment.updating.isConfiguring = false;
              _this16.handlingComment.updating.isPending = false;
              _this16.handlingComment.updating.cancellationToken = null;

              //this.$emit("entityUpdated")
              _this16.$toasted.show("Comment updated", {
                type: "success"
              });
            case 12:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    getEntity: function getEntity() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var _this17$gettingEntity;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _this17.gettingEntity.isPending = true;
              (_this17$gettingEntity = _this17.gettingEntity.cancellationToken) === null || _this17$gettingEntity === void 0 || _this17$gettingEntity.cancel();
              _this17.gettingEntity.cancellationToken = axios.CancelToken.source();
              _this = _this17;
              _context26.next = 6;
              return request("/v1/stock-transfer-domestics/".concat(_this17.id), "get", null, true, "api", null, _this.gettingEntity.cancellationToken).catch(function (e) {
                _this.gettingEntity.isPending = false;
                _this.gettingEntity.cancellationToken = null;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get stock part", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 6:
              response = _context26.sent;
              _this17.entity = _objectSpread({}, response.data.value);
              _this17.gettingEntity.isPending = false;
              _this17.gettingEntity.cancellationToken = null;
            case 10:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      }))();
    },
    exportPdf: function exportPdf() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var _this$exportingPdf$ca;
        var _this, response, filename;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _this18.exportingPdf.isPending = true;
              _this = _this18;
              (_this$exportingPdf$ca = _this.exportingPdf.cancellationToken) === null || _this$exportingPdf$ca === void 0 || _this$exportingPdf$ca.cancel();
              _this.exportingPdf.cancellationToken = axios.CancelToken.source();
              _context28.next = 6;
              return request("/v1/stock-transfer-domestics/".concat(_this18.id, "/pdf"), "get", null, true, "api", "blob", _this.exportingPdf.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee27$(_context27) {
                    while (1) switch (_context27.prev = _context27.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.exportingPdf.isPending = false;
                          errorData = getErrorData(e, {}, "Unable to get PDF.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context27.stop();
                    }
                  }, _callee27);
                }));
                return function (_x11) {
                  return _ref11.apply(this, arguments);
                };
              }());
            case 6:
              response = _context28.sent;
              filename = "TRANSFER.pdf";
              fileDownload(response.data, filename, "application/pdf");
              _this18.exportingPdf.isPending = false;
            case 10:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      }))();
    },
    goToPurchaseOrder: function goToPurchaseOrder(poId) {
      return {
        name: "adminEditPurchaseOrder",
        params: {
          id: poId
        }
      };
    },
    goToOrder: function goToOrder(orderId) {
      return {
        name: "adminOrderSummary",
        params: {
          id: orderId
        }
      };
    },
    goToProduct: function goToProduct(wine) {
      var routeParams = {};
      var detailsRoute = wine.type == listWineTypes.find(function (x) {
        return x.name === "Spirit";
      }).id ? "adminSpiritsDetails" : "adminWineDetails";
      return {
        name: detailsRoute,
        params: {
          id: wine.id,
          readOnly: true,
          routeParams: routeParams
        }
      };
    },
    open: function open() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _this19.resetData();
              _this19.dialog = true;
              _context29.next = 4;
              return _this19.getEntity();
            case 4:
              return _context29.abrupt("return", new Promise(function (resolve, reject) {
                _this19.resolve = resolve;
                _this19.reject = reject;
              }));
            case 5:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.dialog = false;
        this.resetData();
        this.$emit("closed");
      }
    },
    resetData: function resetData() {
      this.entity = null;
    },
    getFullNameUser: getFullNameUser
  }
};